import { useState, useContext } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Input } from "design-react-kit";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import { TokenContext } from "../../Components/TokenContext";
import ViewPDF from "../../Components/ViewPDF";

function useQuery() {
  return new URLSearchParams(location.search);
}

function CheckRefound(props) {
  const apiToken = useContext(TokenContext);
  const [value, setValue] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState();
  const [userData, setUserData] = useState({
    user: "",
    fiscalcode: "",
    email: "",
  });
  const [validation, setValidation] = useState(false);
  const [isOpen, toggleModal] = useState(false);
  const [isOpenRefuse, toggleModalRefuse] = useState(false);
  const [data, setData] = useState("");
  const [idRefund, setIdRefund] = useState("");
  const [idSubFile, setIdSubFile] = useState("");
  const [displayValue, setDisplayValue] = useState("");
  const [showFileToggle, toggleModalShowFile] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  let query = useQuery();
  const history = useHistory();

  //Scarico PDF
  const downloadFile = async (id) => {
    try {
      const response = await Repo.getFileAllegato(apiToken, id);
      if (response.status === 200) {
        const base64Data = response.data;

        // Calcolo la dimensione del file in MB
        const fileSizeInBytes = atob(base64Data).length;
        const fileSizeInMB = (fileSizeInBytes / (1024 * 1024)).toFixed(2); // Converte in MB

        // Se il file è più grande di 1,5 MB, usa URL.createObjectURL per visualizzare il file
        if (fileSizeInMB > 1.5) {
          // Crea un oggetto Blob per il file
          const byteArray = new Uint8Array(
            atob(base64Data)
              .split("")
              .map((c) => c.charCodeAt(0))
          );
          const blob = new Blob([byteArray], { type: "application/pdf" });

          // Crea un URL temporaneo
          const objectUrl = URL.createObjectURL(blob);

          // Visualizza il PDF utilizzando l'oggetto URL
          setFile();
          var obj = document.createElement("object");
          obj.type = "application/pdf";
          obj.data = objectUrl;
          obj.name = response.name;
          setFile(obj);
          toggleModalShowFile(!showFileToggle);
        } else {
          // Se il file è inferiore a 1,5 MB, visualizzalo come base64
          setFile();
          var obj = document.createElement("object");
          obj.type = "application/pdf";
          obj.data = "data:application/pdf;base64," + base64Data;
          obj.name = response.name;
          setFile(obj);
          toggleModalShowFile(!showFileToggle);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const fetchData = async (id) => {
    try {
      if (id) {
        setIdSubFile(query.get("id"));
        setIdRefund(id);
        await downloadFile(id);
      }

      const response = await Repo.getFileAllegatoIscrizione(apiToken, id);
      if (response.data) {
        const {
          subscriptionUser,
          subscriptionUserFiscalcode,
          subscriptionUserEmail,
          description,
          valore,
          subscriptionUserIBAN,
          state,
          userId,
        } = response.data;
        setUserData({
          user: subscriptionUser,
          fiscalcode: subscriptionUserFiscalcode,
          email: subscriptionUserEmail,
          iban: subscriptionUserIBAN,
          state: state,
          userId: userId,
        });
        setValue(valore);
        setDescription(description);
        setIsDisabled(state === 2);
      } else {
        console.warn("Dati non trovati per l'ID di rimborso:", id);
      }
    } catch (error) {
      console.error("Errore durante il recupero dei dati:", error.message);
    }
  };

  const handleFetchData = () => {
    const idRefund = query.get("idRefund");
    fetchData(idRefund);
  };

  // Chiamare handleFetchData quando il componente viene montato
  useState(() => {
    handleFetchData();
  }, []);

  const confirmPayment = async () => {
    setValidation(true);
    let tempData = {};
    let passedValidation = true;

    tempData["id"] = idSubFile;
    tempData["state"] = 1;

    if (passedValidation) {
      var dataJson = JSON.stringify(tempData);
      setData(dataJson);
      toggleModal(true); // Apri il modal
    }
  };

  const refuseRefound = async () => {
    setValidation(true);
    let tempData = {};
    let passedValidation = true;

    tempData["id"] = idSubFile;
    tempData["state"] = 2;

    if (passedValidation) {
      var dataJson = JSON.stringify(tempData);
      setData(dataJson);
      toggleModalRefuse(true); // Apri il modal
    }
  };

  const refuseRefound2 = async () => {
    setValidation(true);
    let tempData = {};
    let passedValidation = true;
    tempData["id"] = idSubFile;
    tempData["state"] = 2;
    if (passedValidation) {
      var dataJson = JSON.stringify(tempData);
      setData(dataJson);
      if (!props.apiToken) {
        toggleModalRefuse(!isOpenRefuse);
      }
      sendRefundApi(dataJson);
    }
  };

  const sendRefoundApi = async (dataJson) => {
    setIsProcessing(true); // Disabilita il pulsante durante l'elaborazione
    Repo.postUpdateRefund(apiToken, dataJson)
      .then((response) => {
        if (response.status === 200) {
          // Reindirizza alla nuova pagina
          window.location.href = `${props.subfolder}/lista_utenti/cartella_sociale?id=${userData.userId}`;
        } else {
          console.error("Errore nella risposta:", response);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsProcessing(false); // Riabilita il pulsante dopo la fine
      });
  };

  const handleInputChange = (e) => {
    const cleanedValue = e.target.value.replace(/[^\d.,]/g, ""); // permette numeri, virgola e punto
    setValue(cleanedValue.replace(/,/g, ".")); // sostituisci virgola con punto se necessario
  };

  return (
    <>
      <div>
        <h1>Verifica rimborso</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>
            Verifica il rimborso richiesto dagli utenti inserendo il valore
            dell'eventuale rimborso dovuto{" "}
            {file?.name && file?.name !== "undefined" ? ": " + file.name : ""}{" "}
          </p>
        </div>

        <div className="row mb-2">
          <div className="col-12"></div>
        </div>
        <div className="row">
          <ViewPDF
            data={file && file.data}
            length={file && file.data.length}
            type={file && file.type}
          />

          <div className="col-lg-4 pl-5">
            <h3>Riepilogo utente</h3>

            <div>
              Nome cognome:
              <div className="clear"></div>
              <strong>{userData.user}</strong>
              <div className="clear"></div>
              Codice Fiscale: <div className="clear"></div>
              <strong>{userData.fiscalcode.toUpperCase()}</strong>
              <div className="clear"></div>
              Email:
              <div className="clear"></div>
              <strong>{userData.email}</strong>
              <div className="clear"></div>
              IBAN:
              <div className="clear"></div>
              <strong>{userData.iban}</strong>
            </div>

            <hr />

            <div className="clear"></div>

            <p className="mt-2">Valore rimborso richiesto*</p>
            <div className="row mb-4">
              <Input
                id="value"
                infoText="Valore inserito dall'utente in fase di richiesta di rimborso, nel caso modificarlo con l'importo spettante"
                value={String(value)}
                name="Valore rimborso"
                onChange={handleInputChange}
                disabled={isDisabled}
                onBlur={() => {
                  // Formatta il valore solo quando l'utente esce dal campo
                  setValue((value) => Number(value).toFixed(2)); // Arrotonda a due decimali
                }}
                {...(validation &&
                  (!value || !String(value).trim()) && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div",
                  })}
              />
              <p>Rimborso : {displayValue}</p>
            </div>
            <p className="mt-2">Note*</p>
            <div className="row mb-4">
              <Input
                id="description"
                value={description}
                name="Note*"
                disabled={isDisabled}
                onChange={(e) => setDescription(e.target.value)}
                {...(validation &&
                  (description == "" || description == " ") && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div",
                  })}
              />
            </div>

            <div className="d-flex justify-content-around">
              <div>
                <button
                  type="button"
                  className="btn btn-success btn-no-wrap"
                  data-toggle="tooltip"
                  data-placement="top"
                  disabled={isProcessing} // Disabilita il pulsante durante l'elaborazione
                  onClick={confirmPayment}
                  title="Conferma"
                >
                  Conferma
                </button>
              </div>
              <div>
                <button
                  type="button"
                  className="btn btn-warning"
                  data-toggle="tooltip"
                  data-placement="top"
                  disabled={isDisabled}
                  title="Rifiuta"
                  onClick={() => refuseRefound()}
                >
                  Rifiuta
                </button>
              </div>
              <div>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Indietro"
                  onClick={() => history.goBack()}
                >
                  Indietro
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Convalida rimborso"
        body="Confermi di voler accettare il rimborso?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendRefoundApi(data)} // Passa i dati quando confermi
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalRefuse}
        isOpen={isOpenRefuse}
        header="Rifiuto rimborso"
        body="Confermi di voler rifiutare il rimborso?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendRefoundApi(data)}
      ></ModalComponent>
    </>
  );
}

export default CheckRefound;
